import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent {
  headerlinks: { label: string, url: string }[] = [{ label: "Download", url: "download" }, { label: "Help", url: "https://macmillaneducation.secure.force.com/help/bg_productdetail?id=01t4H000006R8q0QAC&language=en_US&retURL=https%3A%2F%2Fmacmillaneducation.secure.force.com%2Fhelp%2Fbg_homepage%3Ffilter%3Daltura%26language%3Den_US%26sortBy%3DPopularity" }];
}